export const applyBackgroundBlur = () => {
  const contentElement = document.querySelector(".content");
  contentElement?.classList.add("bg-blur");
};

export const removeBackgroundBlur = () => {
  const contentElement = document.querySelector(".content");
  contentElement?.classList.remove("bg-blur");
};
